import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Button } from "./Button.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsxs("svg", {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "9",
        cy: "9",
        r: "9"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.75 13.8214C12.75 13.8214 11.4873 13.3246 10.466 12.9268H6.17062C5.6625 12.9268 5.25 12.4891 5.25 11.9499V6.22607C5.25 5.68741 5.6625 5.25 6.17062 5.25H11.8291C12.3375 5.25 12.7497 5.68714 12.7497 6.22634V11.156L12.75 13.8214ZM11.6413 10.612C11.6008 10.5599 11.5403 10.5272 11.4745 10.5219C11.4087 10.5165 11.3437 10.539 11.2953 10.5838C11.2872 10.5908 10.4877 11.302 8.99973 11.302C7.53027 11.302 6.71839 10.5959 6.70393 10.583C6.65545 10.5384 6.59052 10.5162 6.52488 10.5216C6.45924 10.5271 6.39886 10.5597 6.35839 10.6117C6.31552 10.6652 6.29455 10.733 6.29973 10.8013C6.30426 10.8694 6.33475 10.933 6.38491 10.9792C6.42295 11.0135 7.33232 11.8229 8.99973 11.8229C10.6674 11.8229 11.5768 11.0135 11.6148 10.9792C11.6649 10.933 11.6953 10.8693 11.6997 10.8013C11.7049 10.7331 11.6841 10.6654 11.6413 10.612Z",
        fill: "white"
      })]
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const BaseFeedbackButton = (t0, ref) => {
  const $ = _c(6);
  const {
    children,
    icon: t1,
    size: t2,
    onPress
  } = t0;
  const icon = t1 === undefined ? true : t1;
  const size = t2 === undefined ? "xs" : t2;
  const t3 = icon ? FeedbackIcon : undefined;
  let t4;
  if ($[0] !== children || $[1] !== onPress || $[2] !== ref || $[3] !== size || $[4] !== t3) {
    t4 = /*#__PURE__*/_jsx(Button, {
      leadingIcon: t3,
      hierarchy: "feedback",
      onPress: onPress,
      size: size,
      buttonRef: ref,
      children: children
    });
    $[0] = children;
    $[1] = onPress;
    $[2] = ref;
    $[3] = size;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export const FeedbackButton = /*#__PURE__*/React.forwardRef(BaseFeedbackButton);
//# sourceMappingURL=FeedbackButton.js.map